import authBookingInit   from './steps/authBookingInit.js';
import authLoginAlt      from './steps/authLoginAlt.js';
import authLogin         from './steps/authLogin.js';
import authRegister      from './steps/authRegister.js';
import authPhone         from './steps/authPhone.js';
import authSms           from './steps/authSms.js';
import authResetPassword from './steps/authResetPassword.js';
import authCheckEmail    from './steps/authCheckEmail.js';
import {t} from "../i18n";

const stepModules = {
    'booking-init': authBookingInit,
    'booking-login-alt': authLoginAlt,
    'booking-login': authLogin,
    'booking-register': authRegister,
    'booking-phone': authPhone,
    'booking-sms': authSms,
    'booking-reset-password': authResetPassword,
    'booking-check-email': authCheckEmail,
    'booking-done': authBookingInit, // TODO: add a screen for back
};

export default function authController({ $, api, state, authData, routes, onComplete, onSocialRedirect }) {

    const auth = authData || {
        isAuth: false,
        isChecked: false,
        skipConfirmation: false,
        skipValidate: false,
        skipUser: false,
        user: null,
    };
    const stepInstances = {};
    const sharedState = {};
    const shared = {
        $, api, state, data: auth, routes, emit, goToStep, complete, sharedState
    };
    let currentStepId = auth.isAuth ? (auth.isChecked === false ? 'booking-phone' : 'booking-done') : 'booking-init';
    if(auth.isAuth) {
        sharedState.email = auth.user.email;
        sharedState.phone = auth.user.phone;
    } else if (auth.skipUser === true) {
        sharedState.noAccount = 1;
        currentStepId = "booking-phone";
    }
    const container = $('<div class="auth-controller"></div>');
    container.on('click', '[data-step]', (e) => {
        e.preventDefault();
        const backStep = $(e.currentTarget).data('step');
        if (backStep) {
            goToStep(backStep);
        }
    });
    auth.state = sharedState;

    function navigateToTop(url) {
        if (url &&
            typeof window !== 'undefined' &&
            typeof window.top !== 'undefined' &&
            typeof window.location !== 'undefined' &&
            typeof window.top.location !== 'undefined'
        ) {
            // Ensure we're not in an iframe
            if (window.top !== window.self) {
                window.top.location.href = url;
            } else {
                window.location.href = url;
            }
        }
    }

    function emit(event, payload) {
        switch (event) {
            case 'social_login_clicked':
                saveState();
                localStorage.setItem('bookingWidgetUrl', window.location.href);
                let url;
                let urlFailedPopup;
                if (payload === 'google') {
                    url = routes.redirectToGoogle;
                    urlFailedPopup = routes.redirectToGooglePopup;
                } else if (payload === 'facebook') {
                    url = routes.facebookRedirect;
                    urlFailedPopup = routes.facebookRedirectPopup;
                } else {
                    console.warn(`Unknown social route: ${payload}`);
                    return;
                }

                if(authData.isEmbedded) {
                    const windowTitle = t('login_with_platform', {platform: t('platform_' + payload)});
                    const popup = window.open(url, windowTitle, 'width=600,height=600');

                    if (!popup || popup.closed || typeof popup.closed == 'undefined') {
                        // Popup was blocked, save state to the server
                        let state = JSON.stringify(window.state);

                        // Send the state to the server before redirecting
                        fetch(routes.storeWindowState, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'X-CSRF-TOKEN': '{{ csrf_token() }}'
                            },
                            body: JSON.stringify({ state: state })
                        }).then(response => {
                            // After saving, redirect to Google login as the top navigator
                            // ('redirectToGoogle', ['internalUrl' => $model->internal_url, 'page' => 'booking', 'exitPopup' => true])
                            navigateToTop(urlFailedPopup);
                        }).catch(error => {
                            console.error('Error storing state on the server:', error);
                        });
                        return;
                    }

                    // Listen for postMessage from the popup
                    window.addEventListener('message', (event) => {
                        if (!event.origin.endsWith('.onTimeAgenda.com'.toLowerCase())) return;

                        const { token, user } = event.data;
                        // Now you can proceed with booking flow

                        event.source.postMessage('received', event.origin);
                        console.log(event.data);
                        /**
                         * {
                         *     "type": "oauth-success",
                         *     "user": {
                         *         "email": "adrian@gmail.com",
                         *         "name": "Adrian Gmail",
                         *         "phone": "0987654321",
                         *         "phone_check": 0
                         *     },
                         *     "sessionToken": null
                         * }
                         */

                        if(event.data.type === 'oauth-success') {
                            auth.isAuth = true;
                            if(event.data.user.phone_check === 1) {
                                onComplete();
                            } else {
                                // phone requires validation
                                sharedState.email = event.data.user.email || '';
                                sharedState.phone = event.data.user.phone || '';
                                goToStep('booking-phone');
                            }
                        } else {
                            console.warn('Login unsuccessful')
                        }
                    });
                } else {

                    navigateToTop(url);
                }
                break;

            case 'auth_error':
                console.error('Auth error:', payload);
                break;

            case 'go_back':
                goToStep(payload.step);
                break;

            default:
                console.warn(`Unknown event: ${event}`);
        }
    }

    function goToStep(stepId, payload = {}) {
        if (!stepModules[stepId]) {
            console.warn(`Unknown auth step: ${stepId}`);
            return;
        }
        currentStepId = stepId;
        renderStep(stepId, payload);
    }

    function complete({user, fullData}) {
        // TODO: data may contain future tokens (jwt,stateless,TBD)
        console.log("User logged in:", user);
        console.log("\tName:", user?.name);
        state.noAccount = sharedState.noAccount ?? 0;
        onComplete?.(user);
    }

    function saveState() {
        onSocialRedirect();
    }

    function renderStep(stepId, payload = {}) {
        const Step = stepModules[stepId];
        const instance = Step({
            ...shared,
            onNext: (nextStep, stepData = {}) => goToStep(nextStep, stepData),
            onComplete: complete,
            onSaveState: saveState,
        });

        stepInstances[stepId] = instance;
        container.html('');
        container.append(instance.render(payload));
    }

    return {
        render(parent) {
            parent.append(container);
            renderStep(currentStepId);
        },

        // Optional API
        goToStep,
        getCurrentStep: () => currentStepId,
        restart: () => goToStep('booking-init'),
        getSharedState: () => shared.sharedState
    };
}
